<template>
    <div>
        <label class="form-label d-block mb-3">{{ field.label }}
            <span v-if="helpText">
                ({{ helpText }})
            </span>
        </label>
        <div
            v-for="(v, index) in $v.value.$each.$iter"
            :key="'array-element-' + index"
            class="ml-3"
        >
            <input-field
                :id="fieldId + '-' + 'mutation-' + index"
                :value="v.$model"
                :placeholder="placeholder"
                :class="!v.$invalid ? 'mb-2' : 'mb-0'"
                :state="!v.$invalid ? null : false"
                :field="{label: ''}"
                :field-name="fieldId + '-' + 'mutation-' + index"
                :inline="false"
                :unit="'fake'"
                :errors="v.$invalid ? {[fieldId + '-' + 'mutation-' + index]: $t('error.required')} : {}"
                class="mb-3"
                form-width="auto"
                no-center-text
                no-label
                @input="valueChanged($event, index)"
            >
                <template v-slot:unit>
                    <i @click="remove(parseInt(index))"  class="clickable col-2 fas fa-trash" :title="$t('utils.remove')" style="font-size: 1.2rem"/>
                </template>
            </input-field>
        </div>
        <b-form-invalid-feedback :state="getGeneralError === ''">
            {{ getGeneralError }}
        </b-form-invalid-feedback>
        <hemocir-button
            :title="$t('utils.add')"
            :class="{'ml-3': this.value.length > 0}"
            font-awesome-icon="fa-plus-circle"
            variant="outline-gray"
            @click="addElement"
        />
    </div>
</template>

<script>
    import {isArray} from 'lodash';
    import fieldMixin from '@/components/fields/FieldMixin';
    import {cloneDeep} from 'lodash';
    import {required} from "vuelidate/lib/validators";
    import InputField from "@/components/fields/InputField";

    export default {
        name: "ArrayField",
        components: {InputField},
        mixins: [fieldMixin],
        computed: {
            getGeneralError() {
                if(isArray(this.localError)) {
                    return this.localError.join(',');
                }
                return '';
            },
        },
        methods: {
            addElement() {
                let newValue = cloneDeep(this.value);
                newValue.push('');
                this.changeValue(newValue);
            },
            remove(index) {
                let newValue = this.value.filter((_, valueIndex) => valueIndex !== index);
                this.changeValue(newValue);
            },
            valueChanged(value, index) {
                const newValue = cloneDeep(this.value);
                newValue[index] = value;
                this.changeValue(newValue);
            },
        },
        validations: {
            value: {
                $each: {
                    required
                }
            }
        }
    };
</script>

<style scoped>
</style>